import { Injectable }                        from '@angular/core';
import { ControlValueAccessor, FormControl } from '@angular/forms';
import { LoggerFront }                       from 'src/app/shared/logger/loggerFront';

@Injectable ()
export abstract class AbstractControlViewAccessor implements ControlValueAccessor {
  public value: string;
  protected onChange: any = () => {
    LoggerFront.log ('onChange');
  };
  protected onTouch: any  = () => {
    LoggerFront.log ('onTouch');
  };

  protected constructor () {
  }

  protected abstract updateDefaultValue (value: any);

  writeValue (value: any): void {
    this.updateDefaultValue (value);
  }

  validate ({ value }: FormControl) {
    return false;
  }

  registerOnChange (fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched (fn: any): void {
    this.onTouch = fn;
  }

}
